import {factory} from './localStorage'

export const CLIENT = factory('Stack-Client')
